<template>
    <div class="box-body bg-round bg-fff contact" >
        <div class="container pa-b-40">
            <Bread class="ma-t-30"/>
            <div class="mb-10">
                <img src="../../img/merge/co1.png" alt="" srcset="" class="w-100 mt-md-4 d-none d-md-block">
                <img src="../../img/merge/co2.png" alt="" srcset="" class="w-100 mt-md-4 d-md-none d-block">
            </div>
            <div class="col-md-7  ma-t-30">
                <div class="line-height-30">
                    SHISW官网: <a href="http://www.shisw.net" target="_black">www.shisw.cc</a> <br>
                    <!-- 合作咨询: lasyzy  （注明来意，非诚勿扰）<span class="btn-showQr" @click="pupupbox=true">查看微信二维码</span><br> -->
                    E-mail: shishortweek@hotmail.com<br>
                    地址：上海市浦东新区懿德路519号<br>
                    Address:519 Yide Road, Pudong New Area, Shanghai<br>
                </div>
                <div class="ma-t-30">
                    <img src="../../img/qrcode.png" alt="" srcset="" width="150">
                    <img src="../../img/20240925095712.jpg" alt="" class="ma-l-40" srcset="" width="150">
                </div>
            </div>
        </div>
        <div>
            <div class="pupup-box" id="pupup-box" v-show="pupupbox">
                <div class="pupup-box-i" onclick="stopPropagation1(event)">
                    <img src="../../img/merge/张海.jpg" alt="" srcset="" class="w-100">
                    <div class="t-center">
                        <i class="iconfont icon-shanchu fon-40" @click="pupupbox=false"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .fon-40{
        font-size:40px;
    }
    .contact{
        min-height: calc(100% - 100px - 61px - 30px);
    }
   .line-height-35 {
        line-height: 35px;
        font-size: 20px;
        font-weight: 400;
        color: #000000;
    }
    .line-height-30{
        line-height: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
    }
    @media (max-width:768px) {
        .con-top{
            margin-top: 40px;
        }
        .img-box img{
            width: 40%;
        }
    }

    @media (min-width:768px) {
        .con-top{
            margin-top: 200px;
        }
        .img-box .col-md-12{
            text-align: center;
            margin-bottom: 40px;
        }
        .img-box img{
            width: 120px;
        }
        #iframeFoot{
            margin-top: 40px;
        }
    }
    .body-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100vh;
    }
    .pupup-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #00000080;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pupup-box-i {
        width: 230px;
        height: auto;
        padding: 20px;
        background-color: #fff;
    }
    .btn-showQr{
        display: inline-block;
        border-radius: 5px;
        border: 1px solid #999;
        cursor: pointer;
        font-size: 14px;
        padding: 0px 4px;
    }
</style>
<script>
    //import {sign,getBanner,getuser,getIndexs} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                pupupbox:false,
                footbottom:123,
            };
        },
        created() {
            console.log("开始开发")
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
        },
    };
</script>
